var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgValidationIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 85C65.9721 85 85 65.9721 85 42.5C85 19.0279 65.9721 0 42.5 0C19.0279 0 0 19.0279 0 42.5C0 65.9721 19.0279 85 42.5 85Z",
    fill: "#44B269"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_403_5981)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63 32.2217C62.7796 32.8361 62.3243 33.2714 61.8745 33.7185C54.3092 41.2313 46.7466 48.7468 39.1885 56.2659C38.6212 56.8299 37.9844 57.1699 37.1822 56.9099C36.8534 56.8029 36.5246 56.5969 36.278 56.3531C33.0567 53.1733 29.8436 49.9845 26.6486 46.7786C26.3631 46.4953 26.2123 46.0797 26 45.7244C26 45.4851 26 45.2459 26 45.0066C26.2367 44.6576 26.4173 44.2492 26.7199 43.973C27.3351 43.4126 28.2863 43.427 28.9511 43.9317C29.1038 44.0477 29.2429 44.1808 29.3793 44.3157C32.0369 46.9549 34.6945 49.5941 37.3493 52.236C37.4514 52.3377 37.5345 52.4564 37.7034 52.6588C37.8335 52.4771 37.9085 52.335 38.0169 52.2261C45.2263 45.057 52.4402 37.8914 59.6487 30.7204C60.2611 30.1114 60.9413 29.8155 61.7986 30.1213C62.4571 30.357 62.7922 30.8769 63 31.503V32.2208V32.2217Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_403_5981"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 27,
    fill: "white",
    transform: "translate(26 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidationIcon);
export default __webpack_public_path__ + "static/media/validation-icon.f72513165e1b9b8b52e2e9a7095bdc4a.svg";
export { ForwardRef as ReactComponent };